// activityTradeExpert
export default {
  routerTitle: '盈寶港美股交易達人',
  shareTitle: '盈寶港美股交易達人，尊享高達HKD600獎勵！',
  shareDesc: '交易即享福利，限時搶！',

  tradeCount: '交易港/美股筆數',
  tradeUnit: '筆',
  tradeUnitMore: '筆以上',
  stockUnit: '股',
  joinNow: '馬上參與',

  cardOneTitle: '活動期間內交易達標，即可獲得獎勵',
  cardOneDesc: '每位客戶最多可獲得其中一份獎勵',
  cardOneTips: '註：獎勵將在活動結束後系統校驗交易筆數，自動發放。',

  wbYsTitle: '盈寶優勢',
  wbDtYsDesc11: '多品種交易',
  wbDtYsDesc12: '支持港股，美股，牛熊渦輪界內證，ETF',
  wbDtYsDesc21: '槓桿放大可能',
  wbDtYsDesc22: '20倍港美股日內融，放大投資機會',
  wbDtYsDesc31: '低利息成本',
  wbDtYsDesc32: '孖展利息低至5.6%，降低投資成本',
  wbDtYsDesc41: '會員特權',
  wbDtYsDesc42: 'V3會員專屬0元佣金，交易1億港元僅需5元平台費',
  wbDtYsDesc51: '智能網格交易',
  wbDtYsDesc52: '條件單、止損止盈，策略在手，交易我有',

  rule: `<span>活動規則：</span><br/>
  1、活動時間：{time} <br/>
  2、活動獎勵：<br/>
  2.1 活動交易獎勵僅限港/美股交易為資格計算種類。（港/美股交易不包含新股、貨幣基金、日內融、投資組合產品）。<br/>
  2.2 活動期間每個客戶最多可獲得其中一份交易獎勵。若用戶活動期間交易101筆或以上，將自動獲取價值高的獎勵進行發放。注: 交易額獎勵不可重複。<br/>
  2.3 交易筆數要求：港/美股交易中，買賣各算一筆。交易須在活動期間（北京時間）內完成成交，超出活動時間的交易不計入交易筆數。<br/>
  2.4 特殊渠道不可參與此活動，詳情可諮詢線上客服。<br/>
  3、獎勵發放說明：<br/>
  3.1 關於股票卡獎勵：股票卡需滿足對應的交易筆數要求，需在活動結束進行校驗最終達標筆數，系統會自動發放股票卡券至個人帳戶，<span>卡券有效期為30天</span>。可前往我的卡券查看，逾期未兌換，不另補發。<br/>
  3.2 交易數據同步至卡券系統有1個交易日延時，請在完成符合指定條件的訂單後下一個交易日再查看使用。<br/>
  3.3 卡券使用說明最終以“我的卡券”中為準。`,

  disclaimers: `<span>免責聲明：</span><br/>
  1、活動獎勵均嚴格按照規則發放，如有任何不符合活動獲獎資格的情況，均無法特殊申請補發獎勵，請遵守活動規則。特殊渠道用戶不參與此活動。<br/>
  2、活動獎勵設置有效期，若未在有效期內及時使用，過期後將不予以補發獎勵，視為自動放棄獲獎資格。<br/>
  3、如發現包括但不限於通過軟體惡意刷獎、手機號碼異常、盜取他人資訊、邀請人IP異常等行為，盈寶證券有權取消或凍結其活動獎勵。上述工作日均以中國香港法定工作日為準。<br/>
  4、活動由盈寶證券（香港）有限公司提供。 本活動並非及不應被視為任何證券、金融產品或工具邀約、招攬、邀請、建議、意見或任何投資決策的建議，亦不應被視為專業意見。 瀏覽本活動的人仕在作出任何投資決定之前，應完全瞭解其風險以及相關法律，涉及的稅項及會計的特點及後果，並根據個人的情況決定投資是否適合個人的財政狀況及投資目標，以及有關風險的承受能力，有需要時應尋找適當的專業意見。盈寶證券（香港）在法律規定範圍內保留更改此條款及細則，更改或終止任何優惠的權利，而毋須另行通知。本活動的獎勵資格及數據確認，以盈寶證券（香港）後台數據為準，如有任何爭議，盈寶證券（香港）保留最終解釋權及決定權。<br/>
  5、蘋果公司沒有以任何方式參與比賽或抽獎，本活動與Apple inc無關。`
}
